import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { clearLoginCache } from '../utils/authVerify'
import { isPrivate } from '../utils/config'
import { post } from '../utils/http'
import logo from '../assets/pathomiq-logo.png'

const Logout = () => {
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await post('/auth/logout', {})
    } catch (err) {
      console.log(err)
    } finally {
      clearLoginCache()
      navigate('/login')
    }
  }

  useEffect(() => {
    handleLogout()
  }, [])  // eslint-disable-line

  return (
    <Box className='d-flex justify-content-center align-items-center' sx={{height: '100vh'}}>
      {isPrivate &&
        <Typography className='position-absolute' sx={{top: '1rem', left: '1rem'}} variant='caption'>
          Internal
        </Typography>
      }
      <Box className='d-flex flex-column align-items-center gap-4 p-5'>
        <img src={logo} width={80} className='mb-4' alt="PATHOMIQ"/>
        <Typography className="text-center" variant='h5'>You're logging out...</Typography>
      </Box>
    </Box>
  )
}

export default Logout;
